import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function ResultsSection() {
  const results = ['Barriga menos estufada', 'Rosto menos inchado', 'Menos sensação de peso após as refeições', 'Roupas vestindo com mais conforto', 'Mais disposição pela manhã', 'Mais controle sobre a alimentação'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-232">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-233">
        <div className="text-center mb-12" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-4" data-id="element-235">
            O Que Você Pode Sentir Nos Primeiros 7 Dias
          </h2>
          <p className="text-sm text-brand-text/60 italic max-w-2xl mx-auto" data-id="element-236">
            Cada corpo responde de um jeito, mas muitas mulheres relatam:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-237">
          {results.map((result, index) => <div key={index} className="bg-brand-cream p-6 rounded-2xl border border-brand-sage/30 flex flex-col items-center text-center shadow-sm" data-id="element-238">
              <SparklesIcon className="w-8 h-8 text-brand-gold mb-4 opacity-80" data-id="element-239" />
              <p className="text-brand-text font-medium" data-id="element-240">{result}</p>
            </div>)}
        </div>

        <div className="bg-brand-sage/10 p-8 rounded-2xl text-center border border-brand-sage/30 max-w-3xl mx-auto" data-id="element-241">
          <p className="text-xl md:text-2xl font-serif font-medium text-brand-dark italic" data-id="element-242">
            "Não é sobre virar outra pessoa em 7 dias. É sobre sentir que seu
            corpo ainda responde."
          </p>
        </div>
      </div>
    </section>;
}